// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const DavisCoPilotSignetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon
      data-iconname="DavisCoPilotSignetIcon"
      ref={forwardedRef}
      {...props}
    >
      <path d="M17.848 8.94a8 8 0 0 0-1.195-2.884 8.05 8.05 0 0 0-3.59-2.948A8 8 0 0 0 8.44 2.653L8.61 3.51a7.15 7.15 0 0 1 4.119.405 7 7 0 0 1 1.231.66l-.553.827a.245.245 0 0 0 .06.333 6 6 0 0 1 1.433 1.49 5.8 5.8 0 0 1 .88 2.125 5.9 5.9 0 0 1 0 2.299 5.8 5.8 0 0 1-.88 2.124 5.9 5.9 0 0 1-1.626 1.626 5.8 5.8 0 0 1-2.123.88 5.9 5.9 0 0 1-2.3 0 5.8 5.8 0 0 1-2.124-.88l-.685 1.025A7.1 7.1 0 0 0 8.61 17.49a7.15 7.15 0 0 0 4.119-.405 7 7 0 0 0 1.231-.66l.485.727a8.05 8.05 0 0 0 2.948-3.59 8 8 0 0 0 .608-3.062 8 8 0 0 0-.152-1.561z" />
      <path d="M14.596 10.97 7.3 14.435a.513.513 0 0 1-.732-.462v-3.755A.5.5 0 0 1 6.621 9.99c.18-.37.601-.959 1.437-.896a.05.05 0 0 1 .047.05v3.207l3.883-1.845-3.883-1.845S7.694 8.467 7.312 8.528a1.9 1.9 0 0 0-.744.324V7.041A.513.513 0 0 1 7.3 6.578l7.296 3.466a.513.513 0 0 1 0 .926" />
      <path d="m6.041 4.575.552.827a.244.244 0 0 1-.06.334 5.92 5.92 0 0 0-2.314 3.615 5.9 5.9 0 0 0 0 2.3A5.8 5.8 0 0 0 5.1 13.775L4.074 14.46a7 7 0 0 0 .712.898.26.26 0 0 1-.005.361l-.438.438a8 8 0 0 1-2.19-4.095 8.03 8.03 0 0 1 .454-4.624 8 8 0 0 1 1.551-2.402A.26.26 0 0 1 4.53 5.03l.431.43a7 7 0 0 1 1.08-.886" />
    </SvgIcon>
  );
});

/**
 * @deprecated Use the AI icons provided within this set.
 * @public
 */
export const DavisCoPilotSignetIcon = /* @__PURE__ */ Object.assign(
  DavisCoPilotSignetIconComponent,
  { displayName: 'DavisCoPilotSignetIcon' },
);
